module.exports = __webpack_public_path__ + "img/thumbnails-8-meal-finder.a56389b2.png";